var _g, _defs, _symbol;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprinkle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 560,
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#a\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 720
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M-1 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0z",
    id: "f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 0a3 3 0 1 0 6 0 3 3 0 1 0-6 0z",
    id: "d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 0A5 5 0 1 0 5 0 5 5 0 1 0-5 0z",
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2-2-4 4z",
    id: "g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6-6-6 6z",
    id: "e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30-30-60 60z",
    id: "h"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1440v560H0z"
  })))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 30,
    y: 30,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 30,
    y: 90,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 30,
    y: 150,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 30,
    y: 210,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 30,
    y: 270,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 30,
    y: 330,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 30,
    y: 390,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 30,
    y: 450,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 30,
    y: 510,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 30,
    y: 570,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 90,
    y: 30,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 90,
    y: 90,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 90,
    y: 150,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 90,
    y: 210,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 90,
    y: 270,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 90,
    y: 330,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 90,
    y: 390,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 90,
    y: 450,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 90,
    y: 510,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 90,
    y: 570,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 150,
    y: 30,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 150,
    y: 90,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 150,
    y: 150,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 150,
    y: 210,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 150,
    y: 270,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 150,
    y: 330,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 150,
    y: 390,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 150,
    y: 450,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 150,
    y: 510,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 150,
    y: 570,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 210,
    y: 30,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 210,
    y: 90,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 210,
    y: 150,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 210,
    y: 210,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 210,
    y: 270,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 210,
    y: 330,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 210,
    y: 390,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 210,
    y: 450,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 210,
    y: 510,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 210,
    y: 570,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 270,
    y: 30,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 270,
    y: 90,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 270,
    y: 150,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 270,
    y: 210,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 270,
    y: 270,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 270,
    y: 330,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 270,
    y: 390,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 270,
    y: 450,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 270,
    y: 510,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 270,
    y: 570,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 330,
    y: 30,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 330,
    y: 90,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 330,
    y: 150,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 330,
    y: 210,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 330,
    y: 270,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 330,
    y: 330,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 330,
    y: 390,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 330,
    y: 450,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 330,
    y: 510,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 330,
    y: 570,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 390,
    y: 30,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 390,
    y: 90,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 390,
    y: 150,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 390,
    y: 210,
    stroke: "rgba(116, 45, 113, 1)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 390,
    y: 270,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 390,
    y: 330,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 390,
    y: 390,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 390,
    y: 450,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 390,
    y: 510,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 390,
    y: 570,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 450,
    y: 30,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 450,
    y: 90,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 450,
    y: 150,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 450,
    y: 210,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 450,
    y: 270,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 450,
    y: 330,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 450,
    y: 390,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 450,
    y: 450,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 450,
    y: 510,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 450,
    y: 570,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 510,
    y: 30,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 510,
    y: 90,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 510,
    y: 150,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 510,
    y: 210,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 510,
    y: 270,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 510,
    y: 330,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 510,
    y: 390,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 510,
    y: 450,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 510,
    y: 510,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 510,
    y: 570,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 570,
    y: 30,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 570,
    y: 90,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 570,
    y: 150,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 570,
    y: 210,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 570,
    y: 270,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 570,
    y: 330,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 570,
    y: 390,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 570,
    y: 450,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 570,
    y: 510,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 570,
    y: 570,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 630,
    y: 30,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 630,
    y: 90,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 630,
    y: 150,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 630,
    y: 210,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 630,
    y: 270,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 630,
    y: 330,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 630,
    y: 390,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 630,
    y: 450,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 630,
    y: 510,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 630,
    y: 570,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 690,
    y: 30,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 690,
    y: 90,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 690,
    y: 150,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 690,
    y: 210,
    stroke: "rgba(23, 23, 24, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 690,
    y: 270,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 690,
    y: 330,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 690,
    y: 390,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 690,
    y: 450,
    stroke: "rgba(5, 25, 41, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 690,
    y: 510,
    stroke: "rgba(116, 45, 113, 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 690,
    y: 570,
    stroke: "rgba(23, 23, 24, 1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinkle);
export default __webpack_public_path__ + "static/media/sprinkle.ca197739aa00743309105f173d5868c1.svg";
export { ForwardRef as ReactComponent };